/**
 * Created by griga on 7/11/16.
 */


import {Routes, RouterModule} from '@angular/router';
import {ModuleWithProviders} from '@angular/core';
import {MainLayoutComponent} from './shared/layout/app-layouts/main-layout.component';
import {LoginComponent} from './pf.main/login/login.component';
import {PasswordComponent} from './pf.main/password/password.component';
import {AuthoritySelectComponent} from './pf.main/authorityselect/authorityselect.component';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'password', component: PasswordComponent },
    { path: 'authorityselect', component: AuthoritySelectComponent },
    {
        path: '',
        component: MainLayoutComponent,
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', loadChildren: 'app/pf.main/home/home.module#HomeModule' },
            // { path: 'dashboard', loadChildren: 'app/+dashboard/+analytics/analytics.module#AnalyticsModule' },
            { path: 'role', loadChildren: 'app/pf.main/role/role.module#RoleModule' },
            { path: 'sequence', loadChildren: 'app/pf.main/sequence/sequence.module#SequenceModule' },
            { path: 'menusetting', loadChildren: 'app/pf.main/menusetting/menusetting.module#MenuSettingModule' },
            { path: 'log', loadChildren: 'app/pf.main/log/log.module#LogModule' },
            { path: 'master', loadChildren: 'app/pf.main/codemaster/codemaster.module#CodeMasterModule' },
            { path: 'roleusers', loadChildren: 'app/pf.main/roleusers/roleusers.module#RoleUsersModule' },
            { path: 'version', loadChildren: 'app/pf.main/version/version.module#VersionModule' },
            { path: 'usermanger', loadChildren: 'app/pf.main/usermanger/usermanger.module#UserMangerModule' },

            { path: 'company', loadChildren: 'app/pf.hr/company/company.module#CompanyModule' },
            { path: 'section', loadChildren: 'app/pf.hr/section/section.module#SectionModule' },
            { path: 'sectionuser', loadChildren: 'app/pf.hr/sectionuser/sectionuser.module#SectionuserModule' },
            { path: 'portal', loadChildren: 'app/pf.main/portal/portal.module#PortalModule' },
            { path: 'base-info-edit', loadChildren: 'app/crm/base-info-edit/base-info-edit.module#BaseInfoEditModule' },
            { path: 'base-info-search', loadChildren: 'app/crm/base-info-search/base-info-search.module#BaseInfoSearchModule' },
            { path: 'filemanagement', loadChildren: 'app/pf.main/filemanagement/filemanagement.module#FileManagementModule' },
            { path: 'message', loadChildren: 'app/pf.main/message/message.module#MessageModule' },
            {
                path: 'licensekeypublish',
                loadChildren: 'app/licauth/producer/licensekeypublish/licensekeypublish.module#LicensekeypublishModule'
            },
            { path: 'proxyauth', loadChildren: 'app/licauth/buyer/proxyauth/proxyauth.module#ProxyauthModule' },
            { path: 'proxystop', loadChildren: 'app/licauth/buyer/proxystop/proxystop.module#ProxystopModule' },

            { path: 'samples', loadChildren: 'app/pf.main/samples/samples.module#SamplesModule' },
            { path: 'licenseinuse', loadChildren: 'app/licauth/buyer/licenseinuse/licenseinuse.module#LicenseInUseModule' },
            { path: 'licensecontract', loadChildren: 'app/licauth/producer/licensecontract/licensecontract.module#LicenseContractModule' },
            { path: 'product', loadChildren: 'app/licauth/producer/product/product.module#ProductModule' },
            { path: 'sales', loadChildren: 'app/market/sales/sales.module#SalesModule' },
            { path: 'notice', loadChildren: 'app/pf.main/notice/notice.module#NoticeModule' }
        ]
    },
    {path: '**', redirectTo: 'home'}
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {useHash: true});



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/app.routing.ts